export const creditCardPayments = {
  VALIDATE_CLIENT_OTHER_CARD_REQUEST: "VALIDATE_CLIENT_OTHER_CARD_REQUEST",
  VALIDATE_CLIENT_OTHER_CARD_COMPLETE: "VALIDATE_CLIENT_OTHER_CARD_COMPLETE",
  VALIDATE_CLIENT_OTHER_CARD_ERROR: "VALIDATE_CLIENT_OTHER_CARD_ERROR",

  CREDIT_CARD_PAY_FROM_LIST_REQUEST: "CREDIT_CARD_PAY_FROM_LIST_REQUEST",
  CREDIT_CARD_PAY_FROM_LIST_COMPLETE: "CREDIT_CARD_PAY_FROM_LIST_COMPLETE",
  CREDIT_CARD_PAY_FROM_LIST_ERROR: "CREDIT_CARD_PAY_FROM_LIST_ERROR",

  CREDIT_CARD_VALIDATE_AMOUNT_REQUEST: "CREDIT_CARD_VALIDATE_AMOUNT_REQUEST",
  CREDIT_CARD_VALIDATE_AMOUNT_COMPLETE: "CREDIT_CARD_VALIDATE_AMOUNT_COMPLETE",
  CREDIT_CARD_VALIDATE_AMOUNT_ERROR: "CREDIT_CARD_VALIDATE_AMOUNT_ERROR",

  SET_CREDIT_CARD_BILL_PAYMENT_FLOW: "SET_CREDIT_CARD_BILL_PAYMENT_FLOW",
  CREDIT_CARD_CLEAR_FLOW_DATA: "CREDIT_CARD_CLEAR_FLOW_DATA",
  CREDIT_CARD_CLEAR_FORM_DATA: "CREDIT_CARD_CLEAR_FORM_DATA",

  CREDIT_CARD_PAY_BILL_REQUEST: "CREDIT_CARD_PAY_BILL_REQUEST",
  CREDIT_CARD_PAY_BILL_COMPLETE: "CREDIT_CARD_PAY_BILL_COMPLETE",
  CREDIT_CARD_PAY_BILL_ERROR: "CREDIT_CARD_PAY_BILL_ERROR",

  CARD_SETTLEMENT_TYPES_REQUEST: "CARD_SETTLEMENT_TYPES_REQUEST",
  CARD_SETTLEMENT_TYPES_COMPLETE: "CARD_SETTLEMENT_TYPES_COMPLETE",
  CARD_SETTLEMENT_TYPES_ERROR: "CARD_SETTLEMENT_TYPES_ERROR",

  CREDIT_CARD_PAY_TO_BANKS_REQUEST: "CREDIT_CARD_PAY_TO_BANKS_REQUEST",
  CREDIT_CARD_PAY_TO_BANKS_COMPLETE: "CREDIT_CARD_PAY_TO_BANKS_COMPLETE",
  PAY_TO_BANKS_ERROR: "PAY_TO_BANKS_ERROR",

  CREDIT_CARD_OTP_CONFIRMATION_REQUEST: "CREDIT_CARD_OTP_CONFIRMATION_REQUEST",
  CREDIT_CARD_OTP_CONFIRMATION_COMPLETE:
    "CREDIT_CARD_OTP_CONFIRMATION_COMPLETE",
  CREDIT_CARD_OTP_CONFIRMATION_ERROR: "CREDIT_CARD_OTP_CONFIRMATION_ERROR",

  CREDIT_CARD_OTP_RESEND_REQUEST: "CREDIT_CARD_OTP_RESEND_REQUEST",
  CREDIT_CARD_OTP_RESEND_COMPLETE: "CREDIT_CARD_OTP_RESEND_COMPLETE",
  OTP_RESEND_ERROR: "OTP_RESEND_ERROR",

  CREDIT_CARD_BILL_PAYMENT_SUCCESS_STATUS: "SUCCESS",
  CREDIT_CARD_BILL_PAYMENT_INITIATE_STATUS: "INITIATE",
  CREDIT_CARD_BILL_PAYMENT_FAILED_STATUS: "FAILED",
  CREDIT_CARD_BILL_PAYMENT_PENDING_STATUS: "PENDING",

  CLEAR_CREDIT_CARD_AVAILABLE_STATUS: "CLEAR_CREDIT_CARD_AVAILABLE_STATUS",

  SET_PAY_FROM: "SET_PAY_FROM",
};
